import styled from 'styled-components';

export const MainContainer = styled.div<{ $backgroundImage?: string }>`
  width: 100%;
  background:
    linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),
    ${(props) => (props.$backgroundImage ? `url(${props.$backgroundImage})` : 'none')};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #fff;
  padding: 48px 24px;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
`;

export const GolfTitle = styled.h1`
  margin: 0 0 5px 0;
  color: #ffffff;
  font-size: 30px;
  font-weight: 800;
  line-height: 140%;
  letter-spacing: 1px;
  text-align: center;
`;

export const GolfInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  margin-bottom: 30px;
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  font-weight: 500;
  line-height: 23px;

  img {
    width: 20px;
    height: 20px;
    flex: 0 0 20px;
  }
`;

export const ButtonGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
`;

/** 아래 섹션들도 같은 폭 규칙을 쓰도록 공통 래퍼 */
export const SectionContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 48px 24px;
`;

export const MyPageContainer = styled.div`
  width: 100%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 20px 0 6px;
`;

export const SectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 800;
  color: #000000;
  margin: 0;
`;

export const ArrowButton = styled.button`
  width: 20px;
  height: 20px;
  background-color: transparent;
  padding: 0;
  border: none;
  cursor: pointer;
`;

export const NoDataText = styled.div`
  color: #636a70;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
  white-space: pre-line;
`;

// LET'S SIGN IN 섹션 스타일
export const SignInTitle = styled.h2`
  font-size: 24px;
  font-weight: 800;
  color: #000000;
  margin: 0 0 20px 0;
  text-align: center;
`;

export const NoDataCard = styled.div`
  display: flex;
  height: 154px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 20px 6px;
  background-color: #f6f7f8;
  border-radius: 16px;
  width: 100%;
`;

export const SignInButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 95px;
`;

export const NoDataButtonContainer = styled.div`
  width: 152px;
`;
